/**
 * @generated SignedSource<<95d6262b8812f61bfa80945feaf66be7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamMemberInlineFragment$data = {
  readonly id: string;
  readonly account: {
    readonly accountDetailConnect: {
      readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailInlineFragment">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment">;
  };
  readonly memberUserId: string | null;
  readonly contactTeamMembers: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberContactFragment">;
  }>;
  readonly memberUserProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"userProfileNameInlineFragment" | "userProfileBaseInlineFragment">;
  };
  readonly permissions: any | null;
  readonly showOnCatalogue: boolean | null;
  readonly deletedAt: any | null;
  readonly updatedAt: any | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "teamMemberInlineFragment";
};
export type teamMemberInlineFragment$key = {
  readonly " $data"?: teamMemberInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamMemberInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "teamMemberInlineFragment"
};

(node as any).hash = "f8f5cab12af7c7b4c46d7c8575f34427";

export default node;
